import React from 'react';
import { getProfileImageUrl } from '../utils/profileImage';
import './UserAvatar.css';

const getInitials = (name) => {
  if (!name) return 'U';
  const parts = String(name).trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
};

const UserAvatar = ({ user, className = '', size = 'md', title }) => {
  const imageUrl = getProfileImageUrl(user?.profileImage);
  const initials = getInitials(user?.firstName || user?.displayName || user?.username || user?.email);

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={`user-avatar-img user-avatar-${size} ${className}`.trim()}
        title={title}
      />
    );
  }

  return (
    <span
      className={`user-avatar-initials user-avatar-${size} ${className}`.trim()}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {initials}
    </span>
  );
};

export default UserAvatar;
